import React, { useEffect } from "react";
import "./chart.css";
import chart1 from "../../assets/chart1.png";
import chart2 from "../../assets/chart2.png";
import chart3 from "../../assets/chart3.png";
import { Link } from "react-router-dom";
import left from "../../assets/left.png";
import { Helmet } from "react-helmet";
function TrimsterChart({selectedTool, setSelectedTool}) {
   useEffect(() => {
      setSelectedTool("/trimester-chart");
    }, []);
  
  return (
    <div className="chart-base">
      <Helmet>
        <title>Pregnancy Trimester Overview - Baby Development & Key Changes</title>
        <meta
          name="description"
          content="Pregnancy trimester chart, baby development overview, physical changes, and key progress for each trimester of your pregnancy journey."
        />
        <meta
          name="keywords"
          content="Pregnancy trimester chart, pregnancy milestones, fetal development"
        />
      </Helmet>
      <div className="chart-main" style={{ position: "relative" }}>
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Trimester Chart</li>
            </ol>
          </nav>
        </div>

        <h1
        className="head1-trim-chart"
          style={{
            color: "#B24C76",
            textTransform: "initial",
            marginBottom: "50px",
            textAlign: "center",
          }}
        >
          Trimester Chart
        </h1>
        <h1
          style={{
            color: "#B24C76",
            textTransform: "initial",
            textAlign: "center",
          }}
        >
          1st Trimester
        </h1>
        <div className="table-chart">
          <img src={chart1} alt="chart1" className="chart1" />
          <div className="table">
            <h5 style={{ textAlign: "center", color: "#C42E1A" }}>
              1st Trimester
            </h5>
            <table className="styled-table">
              <thead>
                <tr className="bgtr">
                  <th>Month</th>
                  <th>Weeks</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bgtr">
                  <td>1</td>
                  <td>1 to 4</td>
                </tr>
                <tr className="bgtr">
                  <td>2</td>
                  <td>5 to 8</td>
                </tr>
                <tr className="bgtr">
                  <td>3</td>
                  <td>9 to 13</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="chart2-data">
          <div>
            <h2 style={{ color: "black", marginBottom: "15px" }}>
              The Early Phase
            </h2>
            <p style={{ textAlign: "justify", color: "grey" }}>
              The first trimester is all about new beginnings. During these
              first few weeks, your body begins major adjustments, and your baby
              is growing rapidly. You may experience early pregnancy symptoms
              like nausea, fatigue, and mood swings. At the end of the first
              trimester, your baby’s organs and body systems are beginning to
              develop. It’s an exciting time but can also be challenging. Since
              this is the most critical stage of your pregnancy journey, it’s
              important to take extra precautions and care.
            </p>
          </div>
          <div style={{ marginTop: "35px" }}>
            <h2 style={{ color: "black", marginBottom: "15px" }}>
              First Trimester: What to Know and Do
            </h2>
            <p style={{ textAlign: "justify", color: "grey" }}>
              In the first trimester, start taking prenatal vitamins with folic
              acid and discuss your medical history with your doctor. Eat a
              balanced diet with fruits, vegetables, and whole grains, and stay
              hydrated. Make sure to rest when feeling fatigued and listen to
              your body.
            </p>
          </div>
        </div>
        {/* trimster 2..................... */}
        <div className="trim3">
          <h1
            style={{
              color: "#B24C76",
              textTransform: "initial",
              textAlign: "center",
            }}
          >
            2nd Trimester
          </h1>
          <div className="table-chart">
            <img src={chart2} alt="chart1" className="chart1" />
            <div className="table1">
              <h5 style={{ textAlign: "center", color: "#C42E1A" }}>
                2nd Trimester
              </h5>
              <table className="styled-table">
                <thead>
                  <tr className="bgtr">
                    <th>Month</th>
                    <th>Weeks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bgtr">
                    <td>4</td>
                    <td>14 to 17</td>
                  </tr>
                  <tr className="bgtr">
                    <td>5</td>
                    <td>18 to 21</td>
                  </tr>
                  <tr className="bgtr">
                    <td>6</td>
                    <td>22 to 26</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="chart1-data">
            <div>
              <h2 style={{ color: "black", marginBottom: "15px" }}>
                The Growth Stage
              </h2>
              <p style={{ textAlign: "justify", color: "grey" }}>
                The second trimester is often considered the most comfortable
                and enjoyable phase of pregnancy for many women. By this time,
                the early symptoms of morning sickness and fatigue begin to
                fade, and you start to feel more energetic. After the first
                trimester, the risk of miscarriage decreases, bringing many
                women a sense of comfort and relief. This is the time when the
                pregnancy truly begins to show, and you’ll likely experience
                noticeable changes in your body.
              </p>
            </div>
            <div style={{ marginTop: "35px" }}>
              <h2 style={{ color: "black", marginBottom: "15px" }}>
                Second Trimester: What to Know and Do
              </h2>
              <p style={{ textAlign: "justify", color: "grey" }}>
                In the second trimester, your belly will begin to show, and you
                may start feeling your baby move. While exciting, you may also
                experience discomforts like back pain, leg cramps, and
                heartburn, so make adjustments for comfort. A balanced diet with
                protein, calcium, and iron is key to supporting your growing
                baby.
              </p>
            </div>
          </div>
        </div>

        {/* trimster 3............................. */}
        <div className="trim3">
          <h1
            style={{
              color: "#B24C76",
              textAlign: "center",
              textTransform: "initial",
            }}
          >
            3rd Trimester
          </h1>
          <div className="table-chart">
            <img src={chart3} alt="chart3" className="chart1" />
            <div className="table2">
              <h5 style={{ textAlign: "center", color: "#C42E1A" }}>
                3rd Trimester
              </h5>
              <table className="styled-table">
                <thead>
                  <tr className="bgtr">
                    <th>Month</th>
                    <th>Weeks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bgtr">
                    <td>4</td>
                    <td>14 to 17</td>
                  </tr>
                  <tr className="bgtr">
                    <td>5</td>
                    <td>18 to 21</td>
                  </tr>
                  <tr className="bgtr">
                    <td>6</td>
                    <td>22 to 26</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="chart1-data">
            <div>
              <h2 style={{ color: "black", marginBottom: "15px" }}>
                The Final Stage
              </h2>
              <p style={{ textAlign: "justify", color: "grey" }}>
                The third trimester is an exciting time as you prepare to meet
                your baby. Physical changes may be challenging, but they signal
                that your body is getting ready for labour. "Practice
                contractions" may become more noticeable, typically irregular,
                and relieved by moving or changing positions. If they become
                regular or more painful, labour might be approaching. Your
                baby’s growth is crucial during this time as they finalize
                preparations to enter the world. Enjoy these last few weeks;
                soon, you'll be holding your little one!
              </p>
            </div>
            <div style={{ marginTop: "35px" }}>
              <h2 style={{ color: "black", marginBottom: "15px" }}>
                Third Trimester: What to Know and Do
              </h2>
              <p style={{ textAlign: "justify", color: "grey" }}>
                In the third trimester, start packing your hospital bag with
                essentials for labor and your newborn. Engage in light
                activities like walking to improve circulation, but rest when
                needed. Stay hydrated by drinking plenty of water and continue
                with regular prenatal check-ups to monitor both your health and
                your baby’s progress.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrimsterChart;
